import apiCalls from '../utils/apiCalls';
import utils from "../utils/utils";

export const SERVICE_AREAS_GET_BEGIN   = 'SERVICE_AREAS_GET_BEGIN';
export const SERVICE_AREAS_GET_SUCCESS = 'SERVICE_AREAS_GET_SUCCESS';
export const SERVICE_AREAS_GET_FAILURE = 'SERVICE_AREAS_GET_FAILURE';
export const SERVICE_AREA_SET_SUCCESS = 'SERVICE_AREA_SET_SUCCESS';
export const SELECTED_SERVICE_AREA_REFRESH_SUCCESS = 'SELECTED_SERVICE_AREA_REFRESH_SUCCESS';

export const serviceAreasGetBegin = () => ({
  type: SERVICE_AREAS_GET_BEGIN
});

export const serviceAreasGetSuccess = serviceAreas => ({
  type: SERVICE_AREAS_GET_SUCCESS,
  payload: { serviceAreas }
});

export const serviceAreaSetSuccess = serviceArea => ({
  type: SERVICE_AREA_SET_SUCCESS,
  payload: { serviceArea }
});

export const serviceAreasGetFailure = error => ({
  type: SERVICE_AREAS_GET_FAILURE,
  payload: { error }
});

export const selectedServiceAreaRefreshSuccess = () => ({
  type: SELECTED_SERVICE_AREA_REFRESH_SUCCESS,
  payload: {}
});

export const refreshSelectedServiceArea = () => {
  return dispatch => {
    dispatch(selectedServiceAreaRefreshSuccess());
  };
};

export const setSelectedServiceArea = serviceArea => {
  return dispatch => {
    dispatch(serviceAreaSetSuccess(serviceArea));
  };
};

export const getServiceAreas = params => {
  return dispatch => {
    dispatch(serviceAreasGetBegin());
    return apiCalls.getServiceAreas(params)
      .then(res => res.data)
      .then(data => {
        dispatch(serviceAreasGetSuccess(data.serviceAreas));
        return data.serviceAreas;
      })
      .catch(error => {
        dispatch(serviceAreasGetFailure(utils.getErrorMessageFromResponse(error, true)));
        throw error;
      });
  };
};